import { SB } from '@play-co/replicant';

export const superLollipopSchema = {
  superLollipop: SB.object({
    // Exclusive win streak for the super lollipop feature
    // This is separate from actual match2 winStreak because
    // it should awlays start from 0 when the feature becomes available
    winStreak: SB.number(),
    // Number of times the user has activated the super lollipop feature
    activationCount: SB.number(),
    // Timestamp in milliseconds when super lollipop feature was last seen by the user
    lastSeenAt: SB.number().optional(),
    // Mark if player has lost super lollipop in the last match, used for rubberbanding
    lostSuperLollipopLastMatch: SB.boolean().optional(),
    // Wether the player has lost the super lollipop this level.
    lostSuperLollipopThisLevel: SB.boolean().optional(),
  }).optional(),
};
